export enum LocalStorageKey {
  LastDataFetchedAt = 'last_data_fetched_at',
  UpdatedKeyData = 'updated_key_data',
}
